import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get auth token
const getAuthHeader = () => {
  const token = localStorage.getItem('adminToken');
  return { Authorization: `Bearer ${token}` };
};

export const quotesAPI = {
  // Get all quotes with filters
  getAll: (filters = {}) => 
    axios.get(`${API_URL}/quotes`, { 
      headers: getAuthHeader(),
      params: filters 
    }),
  
  // Get quote statistics
  getStats: () => 
    axios.get(`${API_URL}/quotes/stats`, { 
      headers: getAuthHeader() 
    }),
  
  // Get single quote
  getById: (id) => 
    axios.get(`${API_URL}/quotes/${id}`, { 
      headers: getAuthHeader() 
    }),
  
  // Create new quote
  create: (quoteData) => 
    axios.post(`${API_URL}/quotes`, quoteData, { 
      headers: getAuthHeader() 
    }),
  
  // Update quote
  update: (id, quoteData) => 
    axios.put(`${API_URL}/quotes/${id}`, quoteData, { 
      headers: getAuthHeader() 
    }),
  
  // Send quote via email
  send: (id) => 
    axios.post(`${API_URL}/quotes/${id}/send`, {}, { 
      headers: getAuthHeader() 
    }),
  
  // Download PDF
  downloadPDF: (id) => 
    axios.get(`${API_URL}/quotes/${id}/pdf`, { 
      headers: getAuthHeader(),
      responseType: 'blob'
    }),
  
  // Delete quote
  delete: (id) => 
    axios.delete(`${API_URL}/quotes/${id}`, { 
      headers: getAuthHeader() 
    }),

  // Get AI pricing suggestion
  getAISuggestion: (orderData) =>
    axios.post(`${API_URL}/quotes/ai-suggest`, orderData, {
      headers: getAuthHeader()
    })
};
